import React from 'react';
import ZoomButton from './ZoomButton';
import { formatTime } from '../../utils/timeFormatter';

const ServiceCard = ({ service, showZoomButton = false }) => {
  const { name, subtext, startTime, endTime, cardStyle } = service;
  const ZOOM_URL = "https://us02web.zoom.us/j/9123235065?pwd=SkcraHVKZG9CaFV1ZnJEN0gxQ1dmZz09";

  // Format time range
  const timeRange = `${formatTime(startTime)} - ${formatTime(endTime)}`;

  return (
    <div className={`diagonal-card ${cardStyle}`}>
      <div className="diagonal-bg"></div>
      <div className="diagonal-content">
        <div className="service-time-badge">{timeRange}</div>
        <div className="service-name-diagonal">{name}</div>
        {subtext && <div className="service-name-cn">{subtext}</div>}
      </div>
      <ZoomButton show={showZoomButton} zoomUrl={ZOOM_URL} />
    </div>
  );
};

export default ServiceCard;
